import { useCallback, useEffect, useState } from "react";
import clsx from "clsx";
import $ from "jquery";

import Navbar from "../../../components/Navbar";
import GameTextBox from "../../../components/GameTextBox";
import getOccurrenceIndexes from "../../../utils/get-occurrence-indexes";
import isEmpty from "../../../utils/is-empty";
import randInt from "../../../utils/get-random-int";
import Section from "../../../components/Section";
import constants from "../../../constants";
import hintSound from "../../../assets/hint.wav";
import revealSound from "../../../assets/reveal.wav";
import failSound from "../../../assets/fail.mp3";

const rowKeys = [
  ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
  ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
  ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
  ["z", "x", "c", "v", "b", "n", "m"],
];

function Game({ onSignInOpen, onGameEnd }) {
  const [selectedCategory, setSelectedCategory] = useState("common phrases");
  const [clue, setClue] = useState("");
  const [fracturedPhrase, setFracturedPhrase] = useState("SLAUGHTERHOUSE");
  const [fracturedPhraseArr, setFracturedPhraseArr] = useState([]);
  const [guessesLeft, setGuessesLeft] = useState(3);
  const [guessedLetters, setGuessedLetters] = useState([]);
  const [, setCorrectylyGuessedLetters] = useState([]);
  const [lettersToGuess, setLettersToGuess] = useState([]);
  const [hintsLeft, setHintsLeft] = useState(3);
  const [guessedPhraseArr, setguessedPhraseArr] = useState([]);
  const [guessedPhraseArrWithoutGaps, setGuessedPhraseArrWithoutGaps] =
    useState([]);
  const [guessedPraseArrChunked, setGuessedPraseArrChunked] = useState([]);
  const [gameRunning, setGameRunning] = useState(true);
  console.log(fracturedPhrase);

  // CATEGORY CLICK HANDLER

  const categoryClickHandler = () => {
    $(".game-text-box.category-box .options").slideToggle();
  };

  // CATEGORY OPTION CHOOSE CLICK HANDLER

  const categoryChooseHandler = (category) => {
    setSelectedCategory(category);
  };

  // RESET GAME

  const resetGame = () => {
    initFraze();
    setGameRunning(true);
    setGuessesLeft(3);
    setHintsLeft(3);
    setCorrectylyGuessedLetters([]);
    setGuessedLetters([]);
    setguessedPhraseArr([]);
  };

  // CHECK IF ANSWER IS CORRECT (CALLED ON TAKING HINT AND KEYBOARD PRESS)

  const checkAnswer = (key, origin) => {
    if (!gameRunning) {
      return;
    }

    setGuessedLetters((prevState) => {
      return [...prevState, key];
    });

    const occurrenceIndexes = getOccurrenceIndexes(fracturedPhraseArr, key);

    let sound = failSound;

    // IF ENTERED CHARACTER IS NOT THE PART OF FRACTURED PHRAZE

    if (isEmpty(occurrenceIndexes)) {
      setGuessesLeft((prevState) => {
        return prevState - 1;
      });
      const audio = new Audio(sound);
      audio.volume = 0.1;
      audio.play();
      return;
    }

    sound = hintSound;

    if (origin === "keyboard") {
      sound = revealSound;
    }

    const audio = new Audio(sound);
    audio.volume = 0.3;
    audio.play();

    // IF ENTERED CHARACTER IS A THE PART OF FRACTURED FRAZE

    setCorrectylyGuessedLetters((prevState) => {
      return [...prevState, key];
    });

    // LETTERS THAT ARE STILL TO BE GUESSED

    setLettersToGuess((prevState) => {
      const newLetters = [...prevState];

      const idxs = getOccurrenceIndexes(newLetters, key);

      idxs.forEach((place, idx) => {
        newLetters.splice(place - idx, 1);
      });

      return newLetters;
    });

    let newGuessedPhraseArr = [...guessedPhraseArr];

    occurrenceIndexes.forEach((place, idx) => {
      newGuessedPhraseArr[place] = key;
    });

    setguessedPhraseArr(newGuessedPhraseArr);
  };

  // HANDLE KEYBOARD INPUT (CHECK ANSWER)

  const keyClickHandler = (e, key) => {
    checkAnswer(key, "keyboard");
  };

  // TAKE HINT

  const takeHintHandler = () => {
    if (hintsLeft === 3) {
      setHintsLeft((prevState) => {
        return prevState - 1;
      });

      checkAnswer(lettersToGuess[0]);
    } else if (hintsLeft > 0) {
      setHintsLeft((prevState) => {
        return prevState - 1;
      });

      checkAnswer(lettersToGuess[randInt(0, lettersToGuess.length - 1)]);
    }
  };

  // INITIALIZE FRAZE

  const initFraze = useCallback(() => {
    const randomPhraze =
      constants.frazez[selectedCategory.toLocaleLowerCase()][
        randInt(
          0,
          constants.frazez[selectedCategory.toLocaleLowerCase()].length
        )
      ];
    const key = Object.keys(randomPhraze)[0].toUpperCase();
    setClue(key);
    const val = Object.values(randomPhraze)[0].toUpperCase();

    setFracturedPhrase(val);
  }, [selectedCategory]);

  // INITIALIZE FRAZE ON PAGE LOAD

  useEffect(() => {
    initFraze();
  }, [initFraze]);

  // SETTING THE FRACTURED ARRAY FOR USER

  useEffect(() => {
    let hiddenString = [];
    let fracturedArr = [];

    for (let i = 0; i < fracturedPhrase.length; i++) {
      const letter = fracturedPhrase[i];
      let hiddenLetter = "_";

      if (letter === " ") {
        hiddenLetter = " ";
      }

      hiddenString.push(hiddenLetter);
      fracturedArr.push(letter);
    }

    setguessedPhraseArr(hiddenString);
    setFracturedPhraseArr(fracturedArr);
  }, [fracturedPhrase]);

  // SETTING GUESSED ARRAY WITHOUT GAPS

  useEffect(() => {
    let arr = [];
    let arr2 = [];
    let arr3 = [];
    guessedPhraseArr.forEach((el) => {
      if (el !== " ") {
        arr.push(el);

        arr2.push(el);
      } else {
        arr3.push(arr2);
        arr2 = [];
      }
    });
    arr3.push(arr2);
    setGuessedPhraseArrWithoutGaps(arr);
    setGuessedPraseArrChunked(arr3);
  }, [guessedPhraseArr]);

  // SETTING ARRAY OF ALL LETTERS, THAT ARE STILL TO BE GUESSED

  useEffect(() => {
    let arr = [];
    fracturedPhraseArr.forEach((el) => {
      if (el !== " ") {
        arr.push(el);
      }

      setLettersToGuess(arr);
    });
  }, [fracturedPhraseArr]);

  // GAME LOST

  useEffect(() => {
    if (guessesLeft === 0) {
      setGameRunning(false);
      onGameEnd("lost", hintsLeft, guessesLeft);
    }
  }, [onGameEnd, hintsLeft, guessesLeft]);

  // GAME WON

  useEffect(() => {
    if (!isEmpty(guessedPhraseArrWithoutGaps)) {
      let areAllGuessed = true;

      guessedPhraseArrWithoutGaps.forEach((el) => {
        if (el === "_") {
          areAllGuessed = false;
        }
      });

      if (areAllGuessed) {
        setGameRunning(false);
        onGameEnd("won", hintsLeft, guessesLeft);
      }
    }
  }, [hintsLeft, guessesLeft, onGameEnd, guessedPhraseArrWithoutGaps]);

  useEffect(() => {
    const ev = document.addEventListener("click", function (e) {
      // console.log(
      //   e.target.parentElement,
      //   document.querySelector(".game-text-box.category-box")
      // );
      console.log(
        e.target.parentElement ===
          document.querySelector(".game-text-box.category-box")
      );
      if (
        e.target.parentElement !==
        document.querySelector(".game-text-box.category-box")
      ) {
        $(".game-text-box.category-box .options").slideUp();
      }
    });

    return () => {
      document.removeEventListener("click", ev);
    };
  }, []);

  return (
    <Section id="game">
      <Navbar
        showHints
        hintsLeft={hintsLeft}
        onSignInOpen={onSignInOpen}
        takeHintHandler={takeHintHandler}
      />

      <div className="d-flex align-items-center flex-column mt-md-4 mt-2 text-center">
        <GameTextBox
          className="c-pointer category-box labeller lg"
          onClick={categoryClickHandler}
        >
          <div className="left">CATEGORY:</div>{" "}
          <div className="right">
            {selectedCategory.toUpperCase()}{" "}
            <div className="options" style={{ display: "none" }}>
              {Object.keys(constants.frazez).map((el, idx) => {
                return (
                  <div
                    onClick={() => categoryChooseHandler(el)}
                    className="option"
                    key={"categ" + idx}
                  >
                    {el}
                  </div>
                );
              })}
            </div>
          </div>
        </GameTextBox>
        <GameTextBox className="clue-box text-center">
          CLUE: {clue.toUpperCase()}
        </GameTextBox>
      </div>

      <div className="guessed-phrase">
        {guessedPraseArrChunked.map((item, idx1) => {
          return (
            <div className="word" key={"word" + idx1}>
              {item.map((el, idx2) => {
                let toShow = el;
                let wasEmpty = false;
                let isGuessed = false;

                if (toShow === "_") {
                  toShow = " ";
                } else if (toShow === " ") {
                  wasEmpty = true;
                } else {
                  isGuessed = true;
                }

                return (
                  <GameTextBox
                    className={clsx({
                      "in-visible": wasEmpty,
                      "is-guessed": isGuessed,
                    })}
                    key={"guessed-letter" + idx1 + idx2}
                  >
                    {toShow}
                  </GameTextBox>
                );
              })}
            </div>
          );
        })}
        {/* {guessedPhraseArr.map((el, idx) => {
          let toShow = el;
          let wasEmpty = false;
          let isGuessed = false;

          if (toShow === "_") {
            toShow = " ";
          } else if (toShow === " ") {
            wasEmpty = true;
          } else {
            isGuessed = true;
          }

          return (
            <GameTextBox
              className={clsx({
                "in-visible": wasEmpty,
                "is-guessed": isGuessed,
              })}
              key={"guessed-letter" + idx}
            >
              {toShow}
            </GameTextBox>
          );
        })} */}
      </div>

      <div className="lives-wrap">
        <div className="lives-box">
          <div className={clsx(guessesLeft < 3 && "show")}>X</div>
          <div className={clsx(guessesLeft < 2 && "show")}>X</div>
          <div className={clsx(guessesLeft < 1 && "show")}>X</div>
        </div>
      </div>

      <div className={clsx({ disabled: !gameRunning }, "keyboard-wrap")}>
        <div className="keyboard">
          {!gameRunning && (
            <div className="reset-btn" onClick={resetGame}>
              <img src="/assets/vectors/reset.svg" alt="reset" />
            </div>
          )}
          {rowKeys.map((row, idx) => {
            return (
              <div key={"board-row" + idx} className="board-row">
                {row.map((el, idx) => {
                  return (
                    <div
                      key={el}
                      className={clsx(
                        "board-key",
                        guessedLetters.includes(el.toUpperCase()) &&
                          "is-guessed"
                      )}
                      onClick={(e) => keyClickHandler(e, el.toUpperCase())}
                    >
                      {el.toUpperCase()}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    </Section>
  );
}

export default Game;
